import type { FaireProductEntity } from "../../entity_types/product";

export const p_7fyqpevyy8: FaireProductEntity = {
  token: "p_7fyqpevyy8",
  type: "product",
  name: '(KG)CATHEDRAL- CITRINE A 13-24"',
  brandToken: "b_b1k03395mh",
  brandName: "Oceanic Linkways Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/7045b114b09eaeaa9fd87eda8b120f64433083188d6c4a7938c5b0c7c7f02f38.jpeg",
  galleryImageUrls: [],
  priceDollars: 22.31,
  description:
    'Our (KG)CATHEDRAL- CITRINE A 13-24" from Oceanic Linkways Inc, a gemstone wholesaler since 1991, is a true testament to our mission of delivering high-quality spiritual products. This spiritual stone, measuring between 13-24", stands as a striking centerpiece. Its warm, golden tones inspire abundance and positivity, making it an ideal choice for those seeking to enhance their spiritual journey. Perfect for home decor or as a unique gift, our Citrine Cathedral is a beautiful addition to any collection.',
  tags: [],
  msrpDollars: 89.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:50.475Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
